export default __webpack_public_path__ + "static/media/Design Solution.79b109d8.jpg";